import Layout from "@/components/Layout";
import EventCard from "@/components/EventCard";
import { events } from "@/data/content";
import { useLang } from "@/context/LanguageContext";

export default function EventsPage() {
  const { t, lang } = useLang();
  const upcoming = events.filter((e) => !e.soldOut);
  const past = events.filter((e) => e.soldOut);

  return (
    <Layout>
      <section className="container-sv pt-24 pb-12">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-8 h-px bg-neon-purple" style={{ background: "var(--sv-purple)" }} />
          <span className="font-display uppercase tracking-[0.35em] text-[10px] text-white/60">
            {lang === "en" ? "Lineup" : "Program"}
          </span>
        </div>
        <h1 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tight leading-[0.92]" data-testid="events-page-title">
          <span className="text-white">All </span>
          <span className="neon-text-purple">{t.pages.events.title.replace(/^All\s*|^Všechny\s*/i, "")}</span>
        </h1>
        <p className="mt-5 text-white/65 font-body text-lg max-w-xl">
          {t.pages.events.subtitle}
        </p>
      </section>

      <section className="container-sv pb-20">
        {upcoming.length === 0 ? (
          <p className="text-white/55 font-body">{t.pages.events.empty}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {upcoming.map((e) => (
              <EventCard key={e.id} event={e} />
            ))}
          </div>
        )}
      </section>

      {past.length > 0 && (
        <section className="container-sv pb-32">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-px bg-white/30" />
            <span className="font-display uppercase tracking-[0.35em] text-[10px] text-white/50">
              {t.pages.events.past}
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8 opacity-70">
            {past.map((e) => (
              <EventCard key={e.id} event={e} />
            ))}
          </div>
        </section>
      )}
    </Layout>
  );
}
